import { Action, createReducer, on } from "@ngrx/store";

import { HrrActions } from "../../actions/hrr.actions";
import { HrrState } from "../../models/hrr/hrr.state";

export const initialHrrState: HrrState = {
	loading: false,
	loaded: false
};

const reducer = createReducer(
	initialHrrState,
	on(HrrActions.list.get, (state) => (state.loaded ? state : { ...state, loading: true, error: undefined })),
	on(HrrActions.list.getApi, (state) => ({ ...state, loading: true, error: undefined })),
	on(HrrActions.list.getSuccess, (state, { list, fetchedAt }) => ({
		...state,
		list,
		fetchedAt,
		loaded: true,
		loading: false,
		error: undefined
	})),
	on(HrrActions.list.getFail, (state, { error }) =>
		state.list ? { ...state, loading: false } : { ...state, error, loaded: false, loading: false }
	)
);

export function hrrReducer(state: HrrState | undefined, action: Action): HrrState {
	return reducer(state, action);
}
